import classNames from 'classnames'
import React from 'react'

import { MealPlan } from '@/api/types'
import { Button } from '@/components/Button'
import { Dialog, DialogTrigger, Modal, ModalContent, ModalHeader } from '@/components/Modal'
import { SORTED_MEALS } from '../constants'
import DayMealPlanCard from './DayMealPlanCard'
import MealDetail from './MealDetail/MealDetail'
import { GetReplacementsFn } from './CreateMealPlan'
import { t } from 'i18next'

type Props = {
  dayPlan: MealPlan[]
  mainUserId: number
  dayOfWeek: string
  onReplaceMeal: any
  getReplacements: GetReplacementsFn
  replacedMealIds: Record<string, boolean>
}

export default function DayMealPlan({ dayPlan, mainUserId, getReplacements, replacedMealIds }: Props) {
  let dayMeals = dayPlan.sort(
    (a, b) => SORTED_MEALS.indexOf(a.mealOfDay) - SORTED_MEALS.indexOf(b.mealOfDay),
  )
  return (
    <div>
      <div className="dayMealPlan">
        {dayMeals.map((dp) => (
          <DialogTrigger key={dp.mealOfDay}>
            <Button
              className={classNames('mealPlanForMeal', {
                'mealPlanForMeal--replaced': replacedMealIds[`${dp.dayOfWeek}-${dp.mealOfDay}`],
              })}
            >
              {replacedMealIds[`${dp.dayOfWeek}-${dp.mealOfDay}`] && (
                <span className="mealPlanReplacedBadge">{t('mealPlan.updatedBadge')}</span>
              )}
              <DayMealPlanCard dayPlan={dp} mainUserId={mainUserId} />
            </Button>
            <Modal style={{ height: '90%' }}>
              <Dialog>
                {({ close }) => (
                  <>
                    <ModalHeader onClose={close}>
                      Meal detail - {t(`profile.dayOfWeek.${dp.dayOfWeek}`)} -{' '}
                      {t(`mealOfDay.${dp.mealOfDay}` as any)}
                    </ModalHeader>

                    <ModalContent>
                      <MealDetail
                        dayPlan={dp}
                        mainUserId={mainUserId}
                        getReplacements={getReplacements}
                      />
                    </ModalContent>
                  </>
                )}
              </Dialog>
            </Modal>
          </DialogTrigger>
        ))}
      </div>
    </div>
  )
}
